import { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useLazyGetLoginHistoryQuery } from "../../services/activityLog";
import { ACTIVITY_MODULES } from "../../constants/enums";
import Pagination from "../../components/Panigation";
const LoginHistory = ({ userId }: { userId: string }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(0);

  const [getLoginHistory] = useLazyGetLoginHistoryQuery();

  // const historyData: any[] = [];
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [historyData, setHistoryData] = useState<any[]>([]);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  // Filter data based on search term
  // const filteredData = historyData.filter(
  //   (item) =>
  //     item.loginTime.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     item.ipAddress.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     item.device.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     item.status.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const formatEnumLabel = (key: string): string =>
    key
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  // Helper function to get module name from enum
  const getModuleName = (moduleValue: number): string => {
    const moduleKey = Object.keys(ACTIVITY_MODULES).find(
      (key) =>
        ACTIVITY_MODULES[key as keyof typeof ACTIVITY_MODULES] === moduleValue
    );
    return moduleKey ? formatEnumLabel(moduleKey) : `Module ${moduleValue}`;
  };

  const fetchLoginHistory = async () => {
    try {
      const response = await getLoginHistory({
        userId: userId,
        page: page,
        limit: pageSize,
      }).unwrap();
      if (response?.statusCode === 200 && response?.data) {
        setHistoryData(response?.data.logs || []);
        setTotalPages(response?.data.totalPages || 0);
      }
    } catch (error: any) {
      console.error("Failed to fetch login history:", error);
    }
  };

  useEffect(() => {
    fetchLoginHistory();
  }, [page, pageSize]);

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />
        </div>
      </div>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Login Time</TableCell>
              <TableCell>IP Address</TableCell>
              <TableCell>Module</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {historyData.length > 0 ? (
              historyData.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    {row.createdAt
                      ? new Date(row.createdAt).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                      : "N/A"}
                  </TableCell>
                  <TableCell>{row.ipAddress}</TableCell>
                  <TableCell>{getModuleName(row.module)}</TableCell>
                  <TableCell>{row.details}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {totalPages > 0 && (
        <Pagination
          module={historyData || []}
          page={page}
          setPage={setPage}
          limit={pageSize}
          setLimit={setPageSize}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      )}
    </>
  );
};

export default LoginHistory;
